@if(shouldShowAppBanner){
<app-gate />
}
@if(!shouldShowAppBanner){
<div class="app" mwpAppAutoDisable [ngClass]="{'logged-in': isLoggedIn}" [ngStyle]="{ 'background-image': loginImage}">
  @if (!isLoggedIn) {
  <div class="app-divider header">
    <div class="app-divider-container">
      <mwp-header-login />
    </div>
  </div>
  }
  @if (isLoggedIn) {
  <div class="app-divider header">
    <div class="app-divider-container">
      <mwp-header />
    </div>
  </div>
  <!-- <div class="app-divider sub-header-divider">
    </div> -->
  }
  <div class="app-body-container app-divider">
    <div #appBody class="app-divider-container app-body" [ngClass]="{'app-body-vertical-scroll': appBodyHaveVerticalScrollbar}">
      <router-outlet />
    </div>
  </div>
  <div class="app-divider footer mt-auto">
    <div class="app-divider-container">
      <mwp-footer />
    </div>
  </div>
  <div class="spinner-container">
    <div class="arc-rotate-double">
      <div class="loader">
        <div class="arc-1"></div>
        <div class="arc-2"></div>
      </div>
    </div>
  </div>
</div>}